import React, {useEffect} from 'react';
import './css/DesignInstallation.css';

const PanelUpgrade = () => {

  useEffect(() => {
        document.title = "Electrical Panel Upgrade | PV Solar";
    }, []);

  return (
    <section className="design-installation solar-house">
      {/* Background Image Container */}
      <div className="gradient-container">
      </div>
      
      {/* Content Container */}
      <div className="content-container">
        <h1 className="design-title">Electrical Panel Upgrades</h1>
        
        <p className="main-description">
          An electrical panel upgrade replaces or enhances your home’s existing breaker box to handle increased power demands. 
          At PV Solar, we specialize in upgrading panels to support solar installations, electric vehicle (EV) chargers, and modern appliances, 
          ensuring safety, efficiency, and future-ready capacity.
        </p>
        
        <div className="service-details">
          <h2 className="design-subtitle">Why Upgrade Your Panel?</h2>
          <p>
            Your electrical panel is the heart of your home’s power system. Older panels (e.g., 60-100 amps) often can’t support today’s energy needs. 
            Upgrading to a 200-amp or higher panel is key for:
          </p>
          <ul>
            <li>
              <span className="check-icon">✓</span>
              <span><strong>Solar Integration:</strong> Safely connects solar arrays to your home and the grid</span>
            </li>
            <li>
              <span className="check-icon">✓</span>
              <span><strong>EV Charging:</strong> Powers Level 2 chargers for faster, reliable EV charging</span>
            </li>
            <li>
              <span className="check-icon">✓</span>
              <span className="highlighted"><strong>Energy Efficiency:</strong> Supports high-demand appliances without overloading</span>
            </li>
            <li>
              <span className="check-icon">✓</span>
              <span className="highlighted"><strong>Safety:</strong> Reduces risks of electrical fires and outages</span>
            </li>
          </ul>
        </div>
        
        <button 
          className="request-button"
          onClick={() => window.location.href = '/panel-upgrade-quote'}
        >Request a Quote
        </button>
      </div>
      
      {/* Services Cards Section */}
      <div className="services-section">
        <div className="services-grid">
        <div className="service-card">
          <h3>Meter Upgrades</h3>
          <p>Update your electrical meter to accommodate solar integration and smart energy monitoring. Modern meters enable precise tracking of energy production and consumption, supporting net metering benefits and optimized energy management.</p>
          <div className="image-container house-1"></div>
        </div>

        <div className="service-card">
          <h3>Feeder Upgrades</h3>
          <p>Enhance your home's main electrical feeders to safely handle increased capacity from solar systems and modern appliances. Our professional feeder upgrades ensure reliable power distribution throughout your home while preventing overloads and safety hazards.</p>
          <div className="image-container house-2"></div>
        </div>
        </div>
      </div>
    </section>
  );
};

export default PanelUpgrade;